import React, { useState, useEffect, useRef } from "react";

const pad2 = (n) => String(n).padStart(2, "0");

// "01a_nodoubles_MP3WRAP.mp3" -> "1a"
// "01a_nodoubles_MP3WRAP.mp3" -> "1a"
function flytOgRytmeLabelFromFilename(filename) {
  if (!filename) return null;

  const base = String(filename).split("/").pop();

  // match "01a" or "1a" at the start
  const m = base.match(/^(\d{1,2})([ab])/i);
  if (!m) return null;

  const num = parseInt(m[1], 10);
  const letter = m[2].toLowerCase();

  return `${num}${letter}`;
}


// fallback label if not Flyt og rytme pattern
function defaultLabel(idx) {
  return String(idx + 1);
}

// Decides which label to show for a given tab
function getTabLabel({ tabsData, idx, courseKey }) {
  if (courseKey === "flyt-og-rytme") {
    const l = flytOgRytmeLabelFromFilename(tabsData?.[idx]);
    console.log("l desktop", l)
    if (l) return l;
  }
  return defaultLabel(idx);
}



const DesktopSelector = ({ tabsData, clickHandler, active, courseKey }) => {
    console.log("desktop", courseKey, tabsData)
    const [activeTabIndex, setActiveTabIndex] = useState(active);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
    const dropdownRef = useRef(null);
    
    useEffect(() => {
        setActiveTabIndex(active);
    }, [active]);
    
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);
    
    if (!tabsData || tabsData.length <= 1) {
        return null;
    }
    
    const getVisibleTabs = () => {
        const maxVisible = 5;
        const tabs = [];
        
        tabs.push(activeTabIndex);
        
        for (let i = 1; i <= Math.floor(maxVisible / 2); i++) {
            if (activeTabIndex - i >= 0 && tabs.length < maxVisible) {
                tabs.unshift(activeTabIndex - i);
            }
        }
        
        for (let i = 1; i <= Math.floor(maxVisible / 2); i++) {
            if (activeTabIndex + i < tabsData.length && tabs.length < maxVisible) {
                tabs.push(activeTabIndex + i);
            }
        }
        
        while (tabs[0] > 0 && tabs.length < maxVisible) {
            tabs.unshift(tabs[0] - 1);
        }
        
        while (tabs[tabs.length - 1] < tabsData.length - 1 && tabs.length < maxVisible) {
            tabs.push(tabs[tabs.length - 1] + 1);
        }
        
        return tabs.sort((a, b) => a - b);
    };
    
    const handleTabClick = (idx) => {
        clickHandler(idx);
        setActiveTabIndex(idx);
    };
    
    const visibleTabs = getVisibleTabs();
    const showFirst = !visibleTabs.includes(0) && activeTabIndex > 1;
    const showLast = !visibleTabs.includes(tabsData.length - 1) && activeTabIndex < tabsData.length - 2;
    const showPrev = activeTabIndex > 0;
    const showNext = activeTabIndex < tabsData.length - 1;
    
    return (
        <div className="flex items-center justify-center gap-1 relative">
            {/* Desktop Navigation with Tab Buttons */}
            <div className="flex items-center justify-center space-x-1 bg-white/20 backdrop-blur-sm rounded-xl p-1 border border-white/30">
                {/* First Button */}
                {showFirst && (
                    <button
                        className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/60 hover:bg-white/80 text-gray-600 border border-white/40 transition-all duration-200 flex-shrink-0 hover:shadow-md"
                        onClick={() => handleTabClick(0)}
                        title="First part"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 19l-7-7 7-7m8 14l-7-7 7-7" />
                        </svg>
                    </button>
                )}
                
                {/* Previous Button */}
                {showPrev && (
                    <button
                        className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/60 hover:bg-white/80 text-gray-600 border border-white/40 transition-all duration-200 flex-shrink-0 hover:shadow-md"
                        onClick={() => handleTabClick(Math.max(0, activeTabIndex - 1))}
                        title="Previous part"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                        </svg>
                    </button>
                )}
                
                {/* Ellipsis before current if needed */}
                {visibleTabs[0] > 0 && (
                    <span className="text-white/70 px-1 text-xs">...</span>
                )}
                
                {/* Visible Tabs */}
                <div className="flex items-center space-x-1">
                    {visibleTabs.map((idx) => (
                        <button
                            key={idx}
                            className={`min-w-[40px] px-2 py-1 rounded-lg transition-all duration-200 font-medium text-xs flex-shrink-0 border
                                        ${
                                            idx === activeTabIndex
                                            ? "bg-gradient-to-r from-blue-500 to-indigo-500 text-white shadow-lg border-blue-400/30 font-semibold"
                                            : "bg-white/60 text-gray-700 hover:text-gray-900 hover:bg-white/80 border-white/40 hover:border-white/60 hover:shadow-md"
                                        }
                                      `}
                            onClick={() => handleTabClick(idx)}
                        >
                            {getTabLabel({ tabsData, idx, courseKey })}
                        </button>
                    ))}
                </div>
                
                {/* Ellipsis after current if needed */}
                {visibleTabs[visibleTabs.length - 1] < tabsData.length - 1 && (
                    <span className="text-white/70 px-1 text-xs">...</span>
                )}
                
                {/* Next Button */}
                {showNext && (
                    <button
                        className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/60 hover:bg-white/80 text-gray-600 border border-white/40 transition-all duration-200 flex-shrink-0 hover:shadow-md"
                        onClick={() => handleTabClick(Math.min(tabsData.length - 1, activeTabIndex + 1))}
                        title="Next part"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </button>
                )}
                
                {/* Last Button */}
                {showLast && (
                    <button
                        className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/60 hover:bg-white/80 text-gray-600 border border-white/40 transition-all duration-200 flex-shrink-0 hover:shadow-md"
                        onClick={() => handleTabClick(tabsData.length - 1)}
                        title="Last part"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 5l7 7-7 7M5 5l7 7-7 7" />
                        </svg>
                    </button>
                )}
            </div>
            
            {/* Dropdown for quick jump */}
            <div className="relative" ref={dropdownRef}>
                <button
                    className="flex items-center justify-center w-8 h-8 rounded-lg bg-white/60 hover:bg-white/80 text-gray-600 border border-white/40 transition-all duration-200 hover:shadow-md relative z-20"
                    onClick={() => setIsDropdownOpen(!isDropdownOpen)}
                    title="All parts"
                    aria-expanded={isDropdownOpen}
                >
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                    </svg>
                </button>
                
                {isDropdownOpen && (
                    <div className="absolute right-0 top-full mt-1 bg-white/95 backdrop-blur-md rounded-lg shadow-xl border border-white/40 py-2 max-h-60 overflow-y-auto z-50 min-w-[120px]">
                        {tabsData.map((_, idx) => (
                            <button
                                key={idx}
                                className={`w-full text-left px-3 py-2 text-sm hover:bg-blue-50/80 transition-colors flex items-center justify-between ${
                                    idx === activeTabIndex 
                                        ? 'bg-blue-500/10 text-blue-700 font-medium' 
                                        : 'text-gray-700'
                                }`}
                                onClick={() => {
                                    handleTabClick(idx);
                                    setIsDropdownOpen(false);
                                }}
                            >
                                <span>Ex. {getTabLabel({ tabsData, idx, courseKey })}</span>
                                {idx === activeTabIndex && (
                                    <svg className="w-4 h-4 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                                        <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                                    </svg>
                                )}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default DesktopSelector;